import { Component, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-filter-modal',
    templateUrl: './filter-modal.component.html',
    styleUrls: ['./filter-modal.component.scss']
})
export class FilterModalComponent {
    currentColumn: string;
    uniqueValues: any[];
    selectedValues: Set<any>;
    searchTerm: string = '';
    public dialogRef = inject(MatDialogRef<FilterModalComponent>);

    filteredValues(): string[] {
        if (!this.searchTerm) {
            return this.uniqueValues;
        }

        const term = this.searchTerm.trim().toLowerCase();
        return this.uniqueValues.filter(value =>
            (value || '(Vazio)').toLowerCase().includes(term)
        );
    }

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.currentColumn = data.column;
        this.uniqueValues = data.values;
        this.selectedValues = new Set(data.selectedValues || []);
    }

    onCheckboxChange(event: Event, value: string) {
        const isChecked = (event.target as HTMLInputElement).checked;
        this.toggleSelection(value, isChecked);
    }

    toggleSelection(value: any, checked: boolean) {
        if (checked) {
            this.selectedValues.add(value);
        } else {
            this.selectedValues.delete(value);
        }
    }

    isAllSelected(): boolean {
        return this.filteredValues().every(value => this.selectedValues.has(value));
    }

    toggleSelectAll(): void {
        const allSelected = this.isAllSelected();
        if (allSelected) {
            this.filteredValues().forEach(value => this.selectedValues.delete(value));
        } else {
            this.filteredValues().forEach(value => this.selectedValues.add(value));
        }
    }

    apply() {
        this.dialogRef.close(Array.from(this.selectedValues));
    }

    close() {
        this.dialogRef.close();
    }
}
